import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  TextField
} from "@mui/material";

const cellSx = {
  backgroundColor: "rgba(47, 53, 71, 0.9)",
  border: "1.5px solid #fff",
  color: "white",
  padding: '10px 8px'
};
const numberSx = {
  ...cellSx,
  textAlign: 'left',
  fontWeight: 600,
};

const TrialPeriodTerminationTable = ({
  proportionalSalary = 0,
  christmasBonus = 0,
  total = 0,
  onValuesChange // Optional callback to notify parent of changes
}) => {
  // Editable actual salary state (string for input)
  const [editableSalary, setEditableSalary] = useState(String(proportionalSalary));

  // Sync external prop changes to state
  useEffect(() => {
    setEditableSalary(String(proportionalSalary));
  }, [proportionalSalary]);

  // Validate and update editable salary on input change
  const handleSalaryChange = (event) => {
    const val = event.target.value;
    if (val === '' || /^\d*\.?\d*$/.test(val)) {
      setEditableSalary(val);
      if (typeof onValuesChange === 'function') {
        onValuesChange({
          proportionalSalary: Number(val) || 0,
          christmasBonus,
        });
      }
    }
  };

  // Calculate total dynamically using editable salary and fixed christmas bonus
  const correctedTotal = (Number(editableSalary) || 0) + (Number(christmasBonus) || 0);

  // Format function for display
  const formatNum = (num) =>
    num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Rows array with editable salary input
  const rows = [
    [
      "Salario Actual",
      <TextField
        value={editableSalary}
        onChange={handleSalaryChange}
        variant="standard"
        inputProps={{
          style: { color: 'white', padding: '6px 8px', fontWeight: 600 },
          inputMode: 'decimal',
          autoComplete: 'off',
          spellCheck: false,
        }}
        sx={{ '& .MuiInputBase-input': { textAlign: 'left', color: 'white' }, width: '120px' }}
      />,
      "Durante el último mes o días trabajados"
    ],
    [
      "Aguinaldo",
      formatNum(christmasBonus),
      "Proporcional o Causado"
    ],
  ];

  return (
    <Box mt={4}>
      <Typography variant="h6" mb={2} fontWeight="bold" color="white">
        Terminacion de Período de Prueba
      </Typography>
      <TableContainer component={Paper} sx={{ background: 'rgba(47,53,71,0.9)' }}>
        <Table>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell sx={cellSx}>{row[0]}</TableCell>
                <TableCell sx={numberSx}>{row[1]}</TableCell>
                <TableCell sx={cellSx}>{row[2]}</TableCell>
              </TableRow>
            ))}
            {/* Total row */}
            <TableRow>
              <TableCell sx={{ ...cellSx, fontWeight: 700 }}>
                Total a Pagar
              </TableCell>
              <TableCell colSpan={2}
                sx={{
                  ...numberSx,
                  background: "rgba(34,189,110,0.15)",
                  color: "#3afa60",
                  fontWeight: "bold",
                  textAlign: 'center',
                  fontSize: 20,
                }}
              >
                {formatNum(correctedTotal)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TrialPeriodTerminationTable;
